// extracted by mini-css-extract-plugin
export default {"wrapper":"Information_wrapper__bgFy+","title":"Information_title__PAEQ+","layout_grid":"Information_layout_grid__wDmzO"};